import React from "react";
import {
  Body1,
  Card,
  Caption1,
  Subtitle2,
  makeStyles,
  tokens
} from "@fluentui/react-components";

const useStyles = makeStyles({
  root: {
    display: "grid",
    gap: tokens.spacingVerticalM,
    padding: tokens.spacingVerticalXXL,
  },
});

interface EmptyStateProps {
  title: string;
  description: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ title, description }) => {
  const styles = useStyles();

  return (
    <Card appearance="filled-alternative">
      <div className={styles.root}>
        <Subtitle2>{title}</Subtitle2>
        <Body1>{description}</Body1>
      </div>
    </Card>
  );
};
